import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2.15 11.25a.65.65 0 0 1 .65.65v1.3h1.3a.65.65 0 1 1 0 1.3H2.15a.65.65 0 0 1-.65-.65V11.9a.65.65 0 0 1 .65-.65m11.7 0a.65.65 0 0 1 .65.65v1.95a.65.65 0 0 1-.65.65H11.9a.65.65 0 0 1 0-1.3h1.3v-1.3c0-.359.29-.65.65-.65M8 2.943q.244-.002.487.123l3.563 2.068c.325.208.5.487.5.857V10.1c0 .37-.175.65-.5.858l-3.563 2.066q-.488.312-.974 0L3.95 10.958c-.325-.208-.5-.488-.5-.858V5.99c0-.37.176-.65.5-.857l3.563-2.068q.243-.124.487-.123M4.75 9.918l2.6 1.494V8.43l-2.6-1.495zm3.9-1.49v2.984l2.6-1.494V6.934zM5.4 5.81 8 7.298l2.6-1.488L8 4.282zM4.1 1.5a.65.65 0 0 1 0 1.3H2.8v1.3a.65.65 0 1 1-1.3 0V2.15a.65.65 0 0 1 .65-.65zm9.75 0a.65.65 0 0 1 .65.65V4.1a.65.65 0 0 1-1.3 0V2.8h-1.3a.65.65 0 1 1 0-1.3z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })